import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

// @ts-ignore missing lib types
import { selectSearchedPhrases } from '@lootboy/lib/slices/searchHistory';

import ButtonClean from '~/components/ButtonClean';

import { useSlotsContext } from '~/redux/slices/slotsFilters';

import { ReactComponent as SearchIcon } from '~/assets/images/iconsLibrary/search.svg';

import styles from './SearchHistory.module.scss';

type THistoryProps = {
  isOpen: boolean;
};

const History: React.FC<THistoryProps> = ({ isOpen }) => {
  const phrases: string[] = useSelector(selectSearchedPhrases);

  const { useSearch } = useSlotsContext();

  const [, setSearch] = useSearch();

  return (
    <div className={classNames(styles.wrapper, { [styles.open]: isOpen })}>
      {phrases.map((phrase) => (
        <ButtonClean
          className={styles.result}
          onClick={() => setSearch(phrase)}
          key={phrase}
        >
          <SearchIcon />
          {phrase}
        </ButtonClean>
      ))}
    </div>
  );
};

export default History;
